import { SupportedLanguage } from "@tumtutor/shared/type";
import i18n, { PostProcessorModule } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend, { HttpBackendOptions } from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { environment } from "./environment";

const replaceInstanceConfigPostProcessor: PostProcessorModule = {
  type: "postProcessor",
  name: "replaceInstanceConfig",
  process(value) {
    if (typeof value === "string") {
      return value.replace(
        /{{instanceName}}/g,
        environment.instanceConfig.name,
      );
    }
    return value;
  },
};

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(replaceInstanceConfigPostProcessor)
  .init<HttpBackendOptions>({
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    supportedLngs: Object.values(SupportedLanguage),
    fallbackLng: SupportedLanguage.EN,
    interpolation: {
      escapeValue: false,
    },
    postProcess: ["replaceInstanceConfig"],
  });

export default i18n;
